export default __webpack_public_path__ + "static/media/01.ab5c3114.jpg";